"use client";

import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";
import {
  digitalMarketingAboutData,
  digitalPortfolioData,
  digitalSolutionsAndProcessData,
  marketingFaqData,
  MarketingHeroData,
  marketingServices,
} from "src/utils/mock/digitalMarketingData";
import AppHero from "src/components/Common/AppHero";
import TechStats from "src/components/Common/TechStats";
import TechsSection from "src/components/Common/TechsSection";
import NavigationSection from "src/components/Common/NavigationSection";
import CommonContactSection from "src/components/Common/CommonContactSection";
import { flutterStatsData, flutterTechnologiesData } from "src/utils/mock/webAppData";

export default function DigitalMarketingComponent({ caseStudies }) {
  const liveProjects = caseStudies?.projects?.liveProjects || [];

  const seoProjects = liveProjects.filter((project) => {
    const hasSeoTech = project.technologies?.some((tech) => tech.name.toLowerCase() === "seo");
    const isActive = project.projectStatus?.toLowerCase() === "active";
    return hasSeoTech && isActive;
  });

  const filteredData = caseStudies
    ? {
        ...digitalPortfolioData,
        projects: {
          liveProjects: seoProjects,
        },
      }
    : digitalPortfolioData;
  const techIcons = filteredData?.projects?.liveProjects[0]?.technologies;
  return (
    <div>
      <AppHero heroData={MarketingHeroData} />
      <TechStats stats={flutterStatsData} />
      <NavigationSection data={marketingServices} leftHeading="Complete Digital" rightHeading=" Marketing Solutions" />
      <WhyChooseUs data={digitalSolutionsAndProcessData} />

      <section className="w-full bg-background-primary text-white px-6! md:px-12! relative overflow-hidden font-sans">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-950/20 blur-[150px] -z-10 rounded-full" />
        <div className="max-w-8xl mx-auto!">
          <PagesServicesSection data={filteredData} />
          <ProcessStepsSection data={flutterTechnologiesData} techIcons={techIcons} />
          <TechsSection sections={digitalMarketingAboutData} mainTitle="About Mobile Digital Marketing" />
        </div>
      </section>

      <FAQSection faqs={marketingFaqData} />
      <CommonContactSection />
    </div>
  );
}
